import {Component, Input, OnInit} from '@angular/core';
import {LicenzeService} from '../../../_services/licenze.service';
import {Licenza} from '../../../_models/Licenza';
import {SearchResult} from '../../../_models/SearchResult';
import {ModuloConfig} from '../../../_models/ModuloConfig';
import {SaveMessage} from '../../../_helpers/save-message';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';

@Component({
  selector: 'app-licenze-config',
  templateUrl: './licenze-config.component.html',
  styleUrls: ['./licenze-config.component.scss'],
  standalone: false
})
export class LicenzeConfigComponent implements OnInit {
  @Input() organizzazioneId: number;
  @Input() roleId = -1;
  @Input() operatoreId = -1;
  licenza: Licenza;
  permessi: ModuloConfig[] = [];
  loadingLicenza = false;
  loadingPermessi = false;
  today = new Date();
  activeTab = 'licenza-periodo';

  constructor(
    private saveMessage: SaveMessage,
    private licenzeService: LicenzeService,
    private organizzazioniService: OrganizzazioniService) { }

  // Il progress-bar e la card "Licenza non disponibile" dipendono da questo. Licenza e permessi si
  // caricano in parallelo con due chiamate indipendenti: se fossero un unico flag booleano, quella
  // più veloce lo riporterebbe a false mentre l'altra è ancora in corso, mostrando per uno
  // sfarfallio "Licenza non disponibile" prima che la licenza sia davvero arrivata.
  get loading(): boolean {
    return this.loadingLicenza || this.loadingPermessi;
  }

  ngOnInit() {
    this.getLicenza();
    this.getPermessiTree();
  }

  getLicenza = () => {
    this.loadingLicenza = true;
    this.licenzeService.getLicenzaFromIdAsync(this.organizzazioneId)
      .then((_licenza: Licenza) => this.licenza = _licenza)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento della licenza."))
      .finally(() => this.loadingLicenza = false);
  };

  createNewLicenza = () => {
    this.loadingLicenza = true;
    this.licenza = {id: 0, organizzazioneId: this.organizzazioneId, activationDate: new Date(), expiryDate: new Date(), maxDispositivi: 0, maxSedi: 0, maxRisorse: 0};
    this.licenzeService.createLicenzaAsync(this.licenza)
      .then(() => this.getLicenza())
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione della licenza."))
      .finally(() => this.loadingLicenza = false);
  };

  getPermessiTree = () => {
    this.loadingPermessi = true;
    this.licenzeService.getModuliConfigFilteredAsync(this.organizzazioneId, this.roleId, this.operatoreId)
      .then((_permessi: SearchResult<ModuloConfig>) => this.permessi = _permessi.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei permessi."))
      .finally(() => this.loadingPermessi = false);
  };

  updateLicenza = async () => {
    this.loadingLicenza = true;
    try {
      await this.licenzeService.updateLicenzaAsync(this.licenza);
      this.saveMessage.messageInfo('Aggiornamento riuscito.');
      await this.refreshPermessiOrganizzazioneAttiva();
    } catch {
      this.saveMessage.messageError("Ci sono problemi con il salvataggio della licenza.");
    } finally {
      this.loadingLicenza = false;
    }
  };

  private async refreshPermessiOrganizzazioneAttiva(): Promise<void> {
    const organizzazioneId = +this.organizzazioneId;
    if (!organizzazioneId || organizzazioneId !== this.organizzazioniService.organizzazioneId) {
      return;
    }

    try {
      await this.licenzeService.refreshModuliOfOrgAsync(organizzazioneId);
    } catch {
      this.saveMessage.messageWarning(
        'Licenza salvata, ma i permessi correnti non sono stati aggiornati. Ricaricare la pagina.'
      );
    }
  }
}
